/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapCommand } from '../map-command.class';
import { Component, ComponentRef, Type, ViewContainerRef } from '@angular/core';
import { LiveSearchCustomUiComponent } from './custom-ui/live-search-custom-ui.component';

export class LiveSearchCommand extends MapCommand {

    invoke() {
        // Live search uses its own UI, no action here
    }

    hasCustomUi(): boolean {
        return true;
    }

    getCustomUiType(): Type<any> {
        return LiveSearchCustomUiComponent;
    }

    createCustomUi<T>(view: ViewContainerRef, type: Type<T>): ComponentRef<T> {
        const componentRef = super.createCustomUi(view, type);
        if (this.attributes?.hasOwnProperty('placeholder')) {
            (componentRef.instance as LiveSearchCustomUiComponent).placeholder = this.attributes['placeholder'];
        }
        return componentRef;
    }
}
